var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04364 16.8077C8.50813 16.9387 8.94881 16.6886 9.09173 16.2062L12.4742 4.61774C12.6112 4.12943 12.3789 3.6828 11.9144 3.54583C11.4559 3.41482 11.0152 3.67089 10.8723 4.14729L7.48982 15.7418C7.35286 16.2241 7.5851 16.6707 8.04364 16.8077ZM14.5942 14.6758L18.8342 10.8408C19.251 10.4656 19.251 9.88199 18.8342 9.50683L14.5942 5.67774C14.219 5.3383 13.7128 5.35021 13.3913 5.70751C13.0697 6.06481 13.1054 6.57099 13.4687 6.90447L17.0834 10.1738L13.4687 13.4431C13.1054 13.7766 13.0697 14.2828 13.3913 14.6401C13.7128 14.9974 14.219 15.0152 14.5942 14.6758ZM5.36983 14.6818C5.73904 15.0212 6.25117 15.0093 6.57275 14.646C6.89432 14.2887 6.85859 13.7825 6.48938 13.4491L2.87467 10.1797L6.48938 6.91638C6.85859 6.57695 6.89432 6.07672 6.57275 5.71347C6.25117 5.35616 5.745 5.34425 5.36983 5.68369L1.12389 9.51278C0.707034 9.88795 0.712989 10.4775 1.12389 10.8467L5.36983 14.6818Z",
    fill: "#09090A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCode);
export default __webpack_public_path__ + "static/media/icon-code.d4808564a0f20abcbb342129de9607f8.svg";
export { ForwardRef as ReactComponent };